import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ChangeDetectionStrategy,
} from '@angular/core';

import { Principal } from 'src/app/core/models/object.models';

@Component({
  selector: 'app-principal-card',
  templateUrl: './principal-card.component.html',
  styleUrls: ['./principal-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class PrincipalCardComponent implements OnInit {
  @Input() principal: any;
  @Input() selected: boolean = false;
  @Input() highlightText: string = '';
  @Input() showDelete: boolean = false;
  @Input() filter: 'all' | 'users' | 'user-groups' = 'user-groups';

  @Output() onObjectSelect: EventEmitter<Principal> = new EventEmitter();
  @Output() onObjectDelete: EventEmitter<Principal> = new EventEmitter();

  constructor() {}

  ngOnInit() {}

  principalClicked() {
    this.onObjectSelect.emit(this.principal);
  }

  deletePrincipal() {
    this.onObjectDelete.emit(this.principal);
  }
}
